import { gql } from '@apollo/client';

export const GET_USER_ASSISTANTS = gql`
  query GetUserAssistants {
    userAssistants {
      id
      customInstructions
      initialMessage
      name
      isShared
      vector {
        id
        files {
          id
          file {
            name
          }
          createdAt
        }
      }
    }
  }
`;

export const TOGGLE_ASSISTANT_SHARE = gql`
  mutation ToggleAssistantShare($assistantId: UUID!) {
    toggleAssistantShare(data: { id: $assistantId }) {
      id
      isShared
    }
  }
`;

export const GET_AI_ASSISTANTS = gql`
  query GetAiAssistants {
    aiAssistants {
      id
      name
      imageUrl
      namespaces
      type
      newMessages {
        content
        createdAt
        id
        inappropriate
        offtopic
        suggestion
        role
        thread {
          id
        }
      }
    }
  }
`;

export const GET_THREADS_BY_ASSISTANT = gql`
  query GetThreadsByAssistant($assistantId: String!, $userId: String!) {
    threads(filters: { assistant: $assistantId, user: { id: $userId } }) {
      id
      block
      newMessages
      createdAt
      updatedAt
    }
  }
`;

export const GET_THREADS_BY_ASSISTANT_WITH_MESSAGES = gql`
  query GetThreadsByAssistantWithMessages($assistantId: String!, $userId: String!) {
    threads(filters: { assistant: $assistantId, user: { id: $userId } }) {
      id
      block
      newMessages
      createdAt
      updatedAt
      messages {
        content
        createdAt
        id
        inappropriate
        offtopic
      }
    }
  }
`;

export const CREATE_THREAD = gql`
  mutation CreateThread(
    $assistantId: String!
    $blockId: String
    $studyGroupId: String
  ) {
    createThread(
      data: {
        assistantId: $assistantId
        block: $blockId
        studyGroupId: $studyGroupId
      }
    ) {
      id
    }
  }
`;

export const CREATE_USER_ASSISTANT = gql`
  mutation CreateUserAssistant($name: String!) {
    createAssistant(data: { name: $name }) {
      customInstructions
      id
      initialMessage
      name
    }
  }
`;

export const UPDATE_USER_ASSISTANT = gql`
  mutation UpdateUserAssitant(
    $assistantId: String!
    $name: String!
    $customInstructions: String!
    $initialMessage: String!
    $file: String
  ) {
    updateAssistant(
      data: {
        id: $assistantId
        name: $name
        customInstructions: $customInstructions
        initialMessage: $initialMessage
        file: $file
      }
    ) {
      id
      customInstructions
      initialMessage
      name
    }
  }
`;

export const GET_THREAD = gql`
  query GetThread($threadId: String!) {
    thread(id: $threadId) {
      id
      newMessages
      createdAt
      updatedAt
      messages {
        content
        createdAt
        id
        inappropriate
        offtopic
        suggestion
        role
        isBlocked
      }
    }
  }
`;

export const CREATE_MESSAGE = gql`
  mutation CreateMessage($threadId: String!, $content: String!) {
    createMessage(data: { threadId: $threadId, content: $content }) {
      id
      messages {
        content
        createdAt
        id
        inappropriate
        offtopic
        suggestion
        role
        isBlocked
      }
    }
  }
`;

export const CREATE_TRIGGER_FROM_BLOCK = gql`
  mutation CreateTriggerFromBlock($id: Int!) {
    createTriggerFromBlock(id: $id)
  }
`;

export const GET_USER_FILES = gql`
  query GetUserFiles {
    userFiles {
      file {
        name
      }
      vectorIds
      id
    }
  }
`;

export const CREATE_FILE = gql`
  mutation CreateFile($file: String!, $vectorId: String) {
    createFile(data: { file: $file, vectorId: $vectorId })
  }
`;
